export const INTERVALS = {
  month: 'month',
  year: 'year',
};

export const TIERS = [
  {
    id: 'starter',
    nameKey: 'Pricing.Tier.Starter',
    descriptionKey: 'Pricing.Tier.Starter.Description',
    popular: false,
    volumes: [
      { people: 100, monthly: 19 },
      { people: 250, monthly: 29 },
      { people: 500, monthly: 39 },
      { people: 1000, monthly: 59 },
      { people: 2500, monthly: 89 },
      { people: 5000, monthly: 129 },
      { people: 10000, monthly: 199 },
    ],
    featureKeys: [
      'Pricing.TierFeature.CoreSurveys',
      'Pricing.TierFeature.UnlimitedSurveys',
      'Pricing.TierFeature.EmailWebLink',
      'Pricing.TierFeature.BasicCustomization',
      'Pricing.TierFeature.DataRetention6Months',
    ],
  },
  {
    id: 'growth',
    nameKey: 'Pricing.Tier.Growth',
    descriptionKey: 'Pricing.Tier.Growth.Description',
    popular: true,
    volumes: [
      { people: 1000, monthly: 99 },
      { people: 2500, monthly: 149 },
      { people: 5000, monthly: 249 },
      { people: 10000, monthly: 399 },
    ],
    featureKeys: [
      'Pricing.TierFeature.EverythingInStarter',
      'Pricing.TierFeature.AdditionalQuestions',
      'Pricing.TierFeature.BranchingLogic',
      'Pricing.TierFeature.AudiencesWebTargeting',
      'Pricing.TierFeature.IntegrationsApi',
      'Pricing.TierFeature.AutoTranslate',
      'Pricing.TierFeature.DataRetention2Years',
    ],
  },
  {
    id: 'scale',
    nameKey: 'Pricing.Tier.Scale',
    descriptionKey: 'Pricing.Tier.Scale.Description',
    popular: false,
    volumes: [
      { people: 1000, monthly: 149 },
      { people: 2500, monthly: 199 },
      { people: 5000, monthly: 299 },
      { people: 10000, monthly: 449 },
      { people: 25000, monthly: 599 },
      { people: 50000, monthly: 899 },
      { people: 100000, monthly: 1499 },
      { people: null, monthly: null, contact: true },
    ],
    featureKeys: [
      'Pricing.TierFeature.EverythingInGrowth',
      'Pricing.TierFeature.SSO',
      'Pricing.TierFeature.AuditLog',
      'Pricing.TierFeature.AutoTagging',
      'Pricing.TierFeature.SMS',
      'Pricing.TierFeature.DataRetention3Years',
      'Pricing.TierFeature.CustomRetention',
    ],
  },
];

export const ALL_VOLUME_STEPS = [
  { people: 100, tierId: 'starter' },
  { people: 250, tierId: 'starter' },
  { people: 500, tierId: 'starter' },
  { people: 1000, tierId: 'starter' },
  { people: 2500, tierId: 'starter' },
  { people: 5000, tierId: 'starter' },
  { people: 10000, tierId: 'starter' },
  { people: 25000, tierId: 'scale' },
  { people: 50000, tierId: 'scale' },
  { people: 100000, tierId: 'scale' },
  { people: null, tierId: 'scale', contact: true },
];

export const getTierVolumePrice = (tier, people, interval = INTERVALS.month) => {
  const volume = tier.volumes.find(v => v.people === people);
  if (!volume) {
    return null;
  }
  if (volume.contact) {
    return { contact: true };
  }
  const { monthly } = volume;
  const price = interval === INTERVALS.year ? monthly * 10 : monthly;
  return { price, people: volume.people };
};

export const getTierVolumeAtIndex = (tier, volumeIndex = 0) => {
  const index = Math.min(Math.max(volumeIndex, 0), tier.volumes.length - 1);
  return tier.volumes[index];
};

export const getVolumeIndexForPlan = (tierId, people) => {
  const tier = TIERS.find(t => t.id === tierId);
  if (!tier) {
    return 0;
  }
  const index = tier.volumes.findIndex(volume => {
    if (volume.contact) {
      return people === null || people === undefined;
    }
    return String(volume.people) === String(people);
  });
  return index >= 0 ? index : 0;
};

export const buildInitialVolumeIndices = (plans = [], currentPlanId = null) => {
  const indices = Object.fromEntries(TIERS.map(tier => [tier.id, 0]));

  if (!currentPlanId || !plans?.length) {
    return indices;
  }

  const plan = plans.find(p => p.id === currentPlanId);
  if (!plan) {
    return indices;
  }

  const tierId = plan.tier || plan.metadata?.tier;
  const people = plan.cf_people ?? plan.metadata?.people ?? null;
  if (tierId) {
    indices[tierId] = getVolumeIndexForPlan(tierId, people);
  }

  return indices;
};

export const getAnnualSavingsMonths = () => 2;

export const findPlanForSelection = (plans, tierId, people, interval) => {
  if (!plans?.length) {
    return null;
  }
  const intervalUnit = interval === INTERVALS.year ? 'year' : 'month';
  return plans.find(plan => {
    const planTier = plan.tier || plan.metadata?.tier;
    const planPeople = plan.cf_people ?? plan.metadata?.people;
    const planInterval = plan.period_unit || plan.metadata?.interval || plan.interval;
    const planPeriod = plan.period || 1;
    const matchesInterval =
      planInterval === intervalUnit &&
      (intervalUnit === 'month' ? planPeriod === 1 : planPeriod === 1);
    return planTier === tierId && String(planPeople) === String(people) && matchesInterval;
  });
};
